"use client";
import React, { useRef, useState, useEffect } from "react";

interface ScrollContainerProps {
  children: React.ReactNode;
  showScrollIndicator?: boolean;
}

const ScrollContainer: React.FC<ScrollContainerProps> = ({
  children,
  showScrollIndicator = true,
}) => {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [showLeftGradient, setShowLeftGradient] = useState(false);
  const [showRightGradient, setShowRightGradient] = useState(false);

  const updateGradients = () => {
    if (!scrollRef.current || !showScrollIndicator) return;

    const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current;

    setShowLeftGradient(scrollLeft > 0);
    setShowRightGradient(scrollLeft < scrollWidth - clientWidth - 1);
  };

  useEffect(() => {
    updateGradients();

    const resizeObserver = new ResizeObserver(updateGradients);
    if (scrollRef.current) {
      resizeObserver.observe(scrollRef.current);
    }

    return () => {
      resizeObserver.disconnect();
    };
  }, [children, showScrollIndicator]);

  return (
    <div className="scroll-container-wrapper" style={{ position: "relative" }}>
      {showScrollIndicator && showLeftGradient && (
        <div
          className="scroll-gradient scroll-gradient-left"

        />
      )}

      <div
        ref={scrollRef}
        className="scroll-container"
        onScroll={updateGradients}

      >
        {children}
      </div>

      {showScrollIndicator && showRightGradient && (
        <div
          className="scroll-gradient scroll-gradient-right"

        />
      )}

    </div>
  );
};

export default ScrollContainer;
